import { fetchHandler, HTTP_METHOD, API_VERSION_ESYMANDANT, limiter } from 'application/api/request_builders'
import { fetchRequestBuilder } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const getMessageDetailsOnFolder = (accountId, akteIdHash, folderId) => {
    const request = fetchRequestBuilder(`${API_VERSION_ESYMANDANT}/e.consult.${accountId}/akten/timeline/${akteIdHash}/folder/${folderId}?Column=CreationDate&Direction=Ascending&Offset=0&Size=-1`, HTTP_METHOD.GET)

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}